export const FALLBACK_ICON = 'fa fa-dollar-sign';

export const EARMARK_ICONS = [
  {
    contains: 'retirement',
    icon: 'fa fa-retirement',
  },
  {
    contains: 'buy a car',
    icon: 'fa fa-car',
  },
  {
    contains: 'education',
    icon: 'fa fa-graduation-cap',
  },
  {
    contains: 'homepurchase',
    icon: 'fa fa-home',
  },
  {
    contains: 'emergencyfund',
    icon: 'adv-icon adv-icon-emergency',
  },
  {
    contains: 'healthcare',
    icon: 'fa fa-health_care',
  },
];

export const ALL_GOALS = 'allgoals';
